import { Stack } from "@mui/material";
import React from "react";
import EditElementTypeMatcher from "./EditElementTypeMatcher";
import useGlobalMatchingField from "Global/Components/CommonComponents/GroupedView/Hooks/useGlobalMatchingField";
import useFindDependedItems from "Global/Hooks/useFindDependedItems/useFindDependedItems";
import { GroupByRadioType } from "Global/Components/CommonComponents/GroupedView/Functions/GroupByRadioType";
import ComponentMemoizer from "Global/Components/ComponentMemoizer/ComponentMemoizer";
import { treeElementRestructure } from "Global/Components/CommonComponents/GroupedView/Functions/treeElementRestructure";
const EditInnerContenetAccordionContent = ({
  GroupId,
  fields,
  control,
  errors,
  setValue,
}) => {
  const MatchingFields = fields?.filter(
    (element) => element?.element?.IdGroupDetail === GroupId
  );
  useGlobalMatchingField(fields);
  const [filteredRootNodes] = useFindDependedItems(MatchingFields);
  const groupedData =treeElementRestructure(GroupByRadioType(filteredRootNodes));


  console.log('groupedData--->',groupedData)

  return (
    <React.Fragment>
      <Stack spacing={1}>
        <ComponentMemoizer
          element={groupedData?.map((data, index) =>
            groupedData?.length > 0 ? (
              <EditElementTypeMatcher
                element={data}
                field={data}
                control={control}
                errors={errors}
                key={index}
                setValue={setValue}
              />
            ) : (
              <></>
            )
          )}
          dependecies={[JSON.stringify(groupedData)]}
        />
      </Stack>
    </React.Fragment>
  );
};

export default EditInnerContenetAccordionContent;
